import React from 'react'
import classnames from 'classnames'

const INPUT_STYLES = "rounded bg-white my-2 focus-within:ring"
const INPUT_LABEL_STYLES = "flex flex-row px-4 py-3"
const INPUT_INPUT_STYLES = "flex-1 mx-1 px-1 bg-transparent focus:outline-none"

export interface ContactFormProps {
    formName?: string
    fieldConfig?: {
        teamsize?: boolean
    }
    inputClassNames?: string
}

const ContactForm = (props: ContactFormProps) => <div className="max-w-sm mx-auto text-left">
    <form name={props.formName ?? "contact"} method="POST" data-netlify="true" netlify-honeypot="bot-field">
        <input type="hidden" name="form-name" value={props.formName ?? "contact"} />
        <div className="hidden">
            <label>Don’t fill this out if you’re human: <input name="bot-field" /></label>
        </div>
        <div className={classnames(INPUT_STYLES, props.inputClassNames)}>
            <label className={INPUT_LABEL_STYLES}>Name:
                <input className={INPUT_INPUT_STYLES} type="text" autoComplete="name" name="name" required />
            </label>
        </div>
        <div className={classnames(INPUT_STYLES, props.inputClassNames)}>
            <label className={INPUT_LABEL_STYLES}>E-Mail:
                <input className={INPUT_INPUT_STYLES} type="email" autoComplete="email" name="email" required />
            </label>
        </div>
        <div className={classnames(INPUT_STYLES, props.inputClassNames)}>
            <label className={INPUT_LABEL_STYLES}>Telefon:
                <input className={INPUT_INPUT_STYLES} type="tel" autoComplete="tel" name="phone" />
            </label>
        </div>
        {(props?.fieldConfig?.teamsize) ? <div className={classnames(INPUT_STYLES, props.inputClassNames)}>
            <label className={INPUT_LABEL_STYLES}>Teamgröße:
                <input className={INPUT_INPUT_STYLES} type="number" min="1" step="1" name="teamsize" />
            </label>
        </div> : null}
        <div className="text-center">
            <button className="btn min-w-0" type="submit">Get in touch</button>
        </div>
    </form>
</div>

export default ContactForm
